import { oc } from "@orpc/contract";
import { z } from "zod";

// The saved filter blob is opaque here: each table's filter shape is owned and
// validated by the consuming page (which parses this through its own Zod schema
// on read, the way the sidebar preference does). Keeping it a generic record
// lets any table persist its filter/sort/pagination state without a per-table
// contract change.
export const TableFilterValueSchema = z.record(z.string(), z.unknown());

export const GetTableFilterConfigInputSchema = z.object({
  tableId: z.string().min(1),
});

export const GetTableFilterConfigResponseSchema = z
  .object({
    filters: TableFilterValueSchema,
  })
  .nullable();

export const UpsertTableFilterConfigInputSchema = z.object({
  tableId: z.string().min(1),
  filters: TableFilterValueSchema,
});

export const UpsertTableFilterConfigResponseSchema = z.object({
  filters: TableFilterValueSchema,
});

export const userTableFilterConfigsContracts = {
  get: oc
    .input(GetTableFilterConfigInputSchema)
    .output(GetTableFilterConfigResponseSchema)
    .route({ method: "GET" }),
  upsert: oc
    .input(UpsertTableFilterConfigInputSchema)
    .output(UpsertTableFilterConfigResponseSchema)
    .route({ method: "POST" }),
} as const;

export type TableFilterValue = z.infer<typeof TableFilterValueSchema>;
export type GetTableFilterConfigInput = z.infer<
  typeof GetTableFilterConfigInputSchema
>;
export type GetTableFilterConfigResponse = z.infer<
  typeof GetTableFilterConfigResponseSchema
>;
export type UpsertTableFilterConfigInput = z.infer<
  typeof UpsertTableFilterConfigInputSchema
>;
export type UpsertTableFilterConfigResponse = z.infer<
  typeof UpsertTableFilterConfigResponseSchema
>;
